import React, { useState, useEffect } from "react";
import { Table, Dialog } from "@jdcfe/legao";
import "./style.scss";
import PermissionDetail from "./../PermissionDetail";
import { queryAuthPackList } from "utils/api";
import { useHistory } from "react-router-dom";
import qs from "qs";

export default function NoticeIndex(props) {
  const [empty, setEmpty] = useState(null);
  const [tableData, setTableData] = useState([]);
  const { onHandleTableData } = props;
  const history = useHistory();
  const urlQuery = qs.parse(location.search, { ignoreQueryPrefix: true });
  const { appKey } = urlQuery;
  useEffect(() => {
    const handleDetail = (authPackId) => {
      Dialog.confirm({
        title: "权限详情",
        children: (
          <PermissionDetail
            authPackId={authPackId}
            appKey={appKey}
          ></PermissionDetail>
        ),
        actions: [],
        wrapStyle: {
          zIndex: 99,
        },
        className: "app_detail",
      });
    };
    const handleHelp = (flag, authPackId, authPackName, articleId) => {
      if (flag) {
        history.push(
          `/app/frame/schemelist?appKey=${appKey}&authId=${authPackId}&authPackName=${encodeURIComponent(
            authPackName
          )}`
        );
      } else {
        history.push(
          `/app/frame/schemedetail?appKey=${appKey}&authId=${authPackId}&authPackName=${encodeURIComponent(
            authPackName
          )}&articleId=${articleId}`
        );
      }
    };
    if(appKey){
    queryAuthPackList({
      appKey: appKey,
      openStateType: null,
    }).then((res) => {
      onHandleTableData(res.data.result);
      setEmpty(res.data.result);
      const resDataArray = [];
      if (res.data.success && res.data.result && res.data.result.length) {
        res.data.result.forEach((item, index) => {
          const resData = {};
          resData.authPackName = item.authPackName;
          resData.authPackDesc = item.authPackDesc;
          // resData.openStateType = <div className="app_status"><i className={`status_icon ${item.openStateType === 2?'noopen':''}`}></i>{item.openStateType === 2?'未订阅':'已开通'}</div> ;
          resData.handle = (
            <div className="app_action">
              <span
                className="per_detail"
                onClick={handleDetail.bind(this, item.authPackId)}
              >
                权限详情
              </span>{" "}
              <span className="per_space">|</span>{" "}
              <span
                className="per_help"
                onClick={() =>
                  handleHelp(
                    item.flag,
                    item.authPackId,
                    item.authPackName,
                    item.articleId
                  )
                }
              >
                对接方案
              </span>
            </div>
          );
          resData.key = "permissiondata" + index;
          resDataArray.push(resData);
          return resDataArray;
        });
        setTableData(resDataArray);
      }
    });
  }
  }, []);

  const tableTitle = [
    {
      title: "权限包名称",
      dataIndex: "authPackName",
      key: "authPackName",
    },
    {
      title: "场景描述",
      dataIndex: "authPackDesc",
      key: "authPackDesc",
    },
    {
      title: "操作",
      dataIndex: "handle",
      key: "handle",
    },
  ];

  return (
    <div className="notice_index">
      {empty != null ? (
        empty ? (
          <Table
            className="per_table"
            columns={tableTitle}
            data={tableData}
            emptyText={"已选条件下暂无数据，请更换筛选条件"}
          />
        ) : (
          ""
        )
      ) : (
        ""
      )}
    </div>
  );
}
